import * as React from 'react'

import { type FormHelperTextProps } from '@material-ui/core/FormHelperText'

import { FieldHelperTextStyled } from './styles/FieldHelperTextStyled'

export interface IFieldHelperTextProps {}

export const FieldHelperText = (props: FormHelperTextProps) => {
  return <FieldHelperTextStyled {...props} />
}
